import axios from 'axios';
import BaseUrl from '../../constant/baseUrl';
export const TOKEN_KEY = 'token';
export const USER_KEY = 'user';

class Services {
    constructor() {
        this.axios = axios.create({ baseURL: '', timeout: 60000 });
        this.axios.interceptors.response.use(
            (res) => res,
            (err) => {
                // Các request thuộc luồng đăng nhập (đổi token, lấy userinfo) tự xử lý lỗi.
                // KHÔNG được xoá session/đá về login ở đây, nếu không lần login đầu sẽ bị
                // đăng xuất ngay khi userinfo lỡ trả 401 dù token vừa lấy đã hợp lệ.
                const url = err.config?.url || '';
                const isAuthFlow = url.includes('/auth/token') || url.includes('/userinfo');
                if (err.response?.status === 401 && !isAuthFlow) {
                    this.clearStorage();
                    // dùng hash route để về đúng app (HashRouter)
                    window.location.href = `${process.env.PUBLIC_URL}/#${BaseUrl.Login}`;
                }
                return Promise.reject(err);
            }
        );
    }

    attachTokenToHeader(token) {
        this.axios.interceptors.request.use((cfg) => {
            cfg.headers = cfg.headers || {};
            cfg.headers.Authorization = `Bearer ${token}`;
            cfg.headers['Accept-Language'] = 'vi';
            return cfg;
        });
    }

    saveTokenStorage(tokenObj) {
        localStorage.setItem(TOKEN_KEY, JSON.stringify(tokenObj));
    }
    getTokenStorage() {
        const t = localStorage.getItem(TOKEN_KEY);
        return t ? JSON.parse(t) : null;
    }
    saveUserStorage(user) {
        localStorage.setItem(USER_KEY, JSON.stringify(user));
    }
    getUserStorage() {
        const u = localStorage.getItem(USER_KEY);
        return u ? JSON.parse(u) : null;
    }
    clearStorage() {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
    }

    get(url, config) {
        return this.axios.get(url, config);
    }
    post(url, data, config) {
        return this.axios.post(url, data, config);
    }
    // ... nếu cần thêm delete/put/patch
}

export default new Services();
